import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, Icon } from "rhombus-react";

import { MENU_DIVIDER } from "utils/constants";
import { confirmDeleteAsset } from "reducers/Confirm";
import { buildSelectedAssets, buildSelectedAssetsToTranscode } from "selectors/Assets";
import { useDispatch, useSelector } from "react-redux";

export default function BulkActionsButton(props){
	const dispatch = useDispatch();
	const { libraryId } = props;
	const routeLocation = useSelector(state => state.router.location.pathname);
	const selected = useSelector(buildSelectedAssets);
	const transcodable = useSelector(buildSelectedAssetsToTranscode);

	const splitActions = [
		{
			name: `Delete Assets (${selected.length})`,
			icon: "delete",
			value: "delete",
			onClick(){
				const type = (selected.length === 1) ? selected[0].assetType : "assets";
				dispatch(confirmDeleteAsset(libraryId, type, selected));
			},
		},
	];

	if(transcodable.length){
		splitActions.unshift(
			{
				name: `Transcode Videos (${transcodable.length})`,
				icon: "fas fa-film",
				value: "transcode",
				renderChild(){
					return (
						<div className="add-creative-link-container">
							<Link to={`${routeLocation}modal/bulk-transcode/`} className="action-item">
								<Icon className="concept-icon" name="fas fa-film" />
								<span className="title social-concept">Transcode Videos ({transcodable.length})</span>
							</Link>
						</div>
					);
				},
			},
			MENU_DIVIDER
		);
	}

	return (
		<Button
			style="block"
			icon="fas fa-check-double"
			theme="blue"
			isDropDown
			addClass="true"
			splitActions={splitActions}
			splitOptions={{ menuClass: 'bulk-actions-menu' }}
			splitValue="bulk-creative-actions"
		>
			Actions
		</Button>
	);
}

BulkActionsButton.displayName = "BulkAssetActionsButton";
BulkActionsButton.propTypes = {
	libraryId: PropTypes.oneOfType([
		PropTypes.number,
		PropTypes.string,
	]),
};
